// React
import { useState } from 'react';
import PropTypes from 'prop-types';
// コンポーネント
import UpdateEmailInput from "./UpdateEmailInput"
import UpdateEmailConfirm from "./UpdateEmailConfirm"
import UpdateEmailSuccess from "./UpdateEmailSuccess"

import sty from '../Settings.module.css';

const UpdateEmail = ({ email, isAdmin }) => {
    // props
    UpdateEmail.propTypes = {
        email: PropTypes.string.isRequired,
        isAdmin: PropTypes.bool.isRequired,
    };

    // メール変更のステップに関する設定
    const [nextStep, setNextStep] = useState('step1');

    const handleClick = (step) => {
        setNextStep(step);
    };

    // 管理者の場合は制限メッセージを表示
    if (isAdmin) {
        return (
            <div className={sty['admin-restriction-message']}>
                <p>
                    管理者はメールアドレスを変更できません。
                </p>
            </div>
        );
    }

    return (
        <div>
            {nextStep === 'step1' && <UpdateEmailInput 
                email={email}
                onClick={() => handleClick('step2')} 
            />}
            {nextStep === 'step2' && <UpdateEmailConfirm 
                onClick={() => handleClick('step3')} 
            />}
            {nextStep === 'step3' && <UpdateEmailSuccess
            />}
        </div>
    )
}

export default UpdateEmail;
